// extracted by mini-css-extract-plugin
module.exports = {"container":"_1-oBGunU flex md-hide lg-hide flex-column p2","header":"_2NQ58sbk bold"};